import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/movement';

const buildMovementParams = ({accountIds, projectIds, types, searchText, from, to} = {}) => {
    const p = new URLSearchParams();
    if (from) p.append('from', from);
    if (to) p.append('to', to);
    if (searchText) p.append('searchText', searchText);
    accountIds?.forEach(id => p.append('accountId', id));
    projectIds?.forEach(id => p.append('projectId', id));
    types?.forEach(t => p.append('type', t));
    return p.toString();
};

export const findAllMovements = (filters = {}) => {
    const qs = buildMovementParams(filters);
    return get(BASE + (qs ? '?' + qs : ''));
};

export const getMovementSummary = (filters = {}) => {
    const qs = buildMovementParams(filters);
    return get(`${BASE}/summary` + (qs ? '?' + qs : ''));
};

export const createMovement = (body) => post(BASE, body);
export const updateMovement = (id, body) => put(`${BASE}/${id}`, body);
export const deleteMovement = (id) => del(`${BASE}/${id}`);
